import { Form, Input, ModalProps, FormProps, Modal, InputNumber } from '@pankod/refine-antd'
import { useGetIdentity } from '@pankod/refine-core'
import { useUserContext } from 'context/user'
import { createUserHistory } from 'gql/mutations'

type EditSectionProps = {
  modalProps: ModalProps
  formProps: FormProps
}

export const EditSection: React.FC<EditSectionProps> = ({ modalProps, formProps }) => {
  const { data: user } = useGetIdentity()
  const { userRole } = useUserContext()
  const onFinish = async (values: any) => {
    return (
      formProps.onFinish &&
      formProps.onFinish({
        ...values,
        updated_by: user?.id

      })
    )
  }
  return (
    <Modal {...modalProps} title="Edit Section">
      <Form {...formProps} layout="vertical" onFinish={async values => {
        let response = await onFinish(values).then((response: any) => {
          if (response) {
            createUserHistory('sections', 'edit', response?.data?.id, user?.id, userRole)
          }

        })

        return response
      }}>
        <Form.Item
          label="Section Name"
          name="name"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item name="updated_by" initialValue={user?.id}>
          <Input type="hidden" />
        </Form.Item>
      </Form>
    </Modal>
  )
}
